// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"232ab18c","403":"37d569de","557":"efcf4a9f","599":"da1c87a3","685":"0d010fb2","880":"d4bf435b"}[chunkId] + ".chunk.css";
};